export const Colors = {
  themeColor: "#fff9e3",
  black: "black",
  menuTextColor: "#4e4a44",
  red: "red",
  menuTextColorHover: "#7F7C71",
  menuIconColor: "#f2f2f0",
  menuListBgColor: "#3fb0b4",
  menuCloseColor: "grey",
  grey: "grey",
  signUpButtonTxt: "#fe5244",
  signuptxtColor: "#fff",
  subHeadingTxt: "hsla(78, 0%, 0%, 0.7)",
  getAiReadyTxt: "hsla(78, 0%, 0%, 0.7)",
  textColor: "hsla(78, 0%, 0%, 0.7)",
  mainHeaderTxtColor: "hsla(78, 0%, 0%, 1)",
  andaihubTxt: "hsla(78, 0%, 0%, 1)",
  transparent: "transparent",
  cardBgColor: "#d0f0e3",
  bgBorderColor: "rgb(208, 240, 228)",
  white: "white",
  footerTxtColor: "hsla(78, 0%, 0%, 0.5)",
  footerTxtColorSub: "hsla(78, 0%, 0%, 0.7)",
  cardTextColor: "hsla(78, 0%, 0%, 0.74)",
  compareFeatureLight: "hsla(182, 48.4%, 47.8%, 0.6)",
  coreFeatureHeadText: "hsla(182.0339, 48.360657%, 47.843136%, 1)",
  chatWithUsColor: "#25d366",
};
